import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SiteLayout } from "@/components/SiteLayout";
import HomePage from "@/pages/HomePage";
import SystemDetailPage from "@/pages/SystemDetailPage";
import PricingPage from "@/pages/PricingPage";
import AboutPage from "@/pages/AboutPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import AcceptableUsePolicyPage from "@/pages/AcceptableUsePolicyPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <SiteLayout>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        {/* /systems landing redirects to home (use dropdown instead) */}
                        <Route
                            path="/systems"
                            element={<Navigate to="/" replace />}
                        />
                        <Route
                            path="/systems/:slug"
                            element={<SystemDetailPage />}
                        />
                        <Route path="/pricing" element={<PricingPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        {/* /contact — deprecated; nav goes directly to book a call */}
                        <Route
                            path="/contact"
                            element={<Navigate to="/" replace />}
                        />
                        <Route path="/privacy" element={<PrivacyPage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/cookies" element={<CookiePolicyPage />} />
                        <Route
                            path="/acceptable-use"
                            element={<AcceptableUsePolicyPage />}
                        />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </SiteLayout>
            </BrowserRouter>
        </div>
    );
}

export default App;
